<div class="layout-topbar">
    <div class="layout-topbar-logo-container">
        <button class="layout-menu-button layout-topbar-action" (click)="layoutService.onMenuToggle()">
            <i class="pi pi-bars"></i>
        </button>
        <a class="layout-topbar-logo" routerLink="/">
            <app-logo></app-logo>
            <span>MyDocs</span>
        </a>
    </div>

    <div class="layout-topbar-actions">
        <div class="layout-config-menu">
            <button type="button" class="layout-topbar-action" (click)="toggleDarkMode()">
                <i [ngClass]="{ 'pi ': true, 'pi-moon': layoutService.isDarkTheme(), 'pi-sun': !layoutService.isDarkTheme() }"></i>
            </button>
            <div class="relative">
                <button
                    class="layout-topbar-action layout-topbar-action-highlight"
                    pStyleClass="@next"
                    enterFromClass="hidden"
                    enterActiveClass="animate-scalein"
                    leaveToClass="hidden"
                    leaveActiveClass="animate-fadeout"
                    [hideOnOutsideClick]="true"
                >
                    <i class="pi pi-palette"></i>
                </button>
                <app-configurator />
            </div>
        </div>

        <button class="layout-topbar-menu-button layout-topbar-action" pStyleClass="@next"
                enterFromClass="hidden" enterActiveClass="animate-scalein" leaveToClass="hidden"
                leaveActiveClass="animate-fadeout" [hideOnOutsideClick]="true">
            <i class="pi pi-ellipsis-v"></i>
        </button>

        <div class="layout-topbar-menu hidden lg:block">
            <div class="layout-topbar-menu-content">
<!--                <button type="button" class="layout-topbar-action">-->
<!--                    <i class="pi pi-calendar"></i>-->
<!--                    <span>Calendar</span>-->
<!--                </button>-->
<!--                <button type="button" class="layout-topbar-action">-->
<!--                    <i class="pi pi-inbox"></i>-->
<!--                    <span>Messages</span>-->
<!--                </button>-->
                <!-- Botão de Perfil -->
                <div class="relative" (click)="toggleProfileMenu()" tabindex="0" (blur)="closeProfileMenu()">
                    <button type="button" class="layout-topbar-action flex items-center gap-2">
                        <i class="pi pi-user"></i>
                        <span>Perfil</span>
                    </button>

                    <!-- Menu suspenso -->
                    <div *ngIf="isProfileMenuOpen"
                         class="absolute right-0 mt-2 w-56 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-xl z-50">

                        <!-- Header com dados do usuário -->
                        <div class="flex flex-col px-4 py-3 border-b border-gray-200 dark:border-gray-700">
                            <span class="text-sm font-semibold text-gray-800 dark:text-white">Olá, {{ userName }}</span>
                            <span class="text-xs text-gray-500 dark:text-gray-400">{{ userEmail }}</span>
                        </div>

                        <a class="flex items-center px-4 py-3 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors cursor-pointer rounded-t-lg"
                           (click)="goToProfile()">
                            <i class="pi pi-cog mr-3 text-primary-500"></i>
                            <span>Configurações</span>
                        </a>

                        <a class="flex items-center px-4 py-3 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors cursor-pointer rounded-b-lg"
                           (click)="logout()">
                            <i class="pi pi-sign-out mr-3 text-red-500"></i>
                            <span>Sair</span>
                        </a>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
